var consts = require('./constants');
var leadFormField = require('./form-field');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');

// Challenger LOP-47 Definitions
var constsChal = require('./constants-lop-47');
var leadFormFieldChal = require('./form-field-lop-47');


function LeadForm($form, options) {
    this.$form = $form;
    this.$submitBtn = $form.find('[type="submit"]');
    this.submitCallbacks = $.Callbacks();

    // Redefining consts and leadFormFeild for AB Testing
    if(options && options.abtest && options.abtest === 'lop-47') {
        consts = constsChal;
        leadFormField = leadFormFieldChal;
    }

    this.init();
    this.attachEvents();
}

LeadForm.prototype.init = function() {
    var validators = this.$form.data('validators') || [consts.BASIC_VALIDATOR];
    var fieldsNames = Object.keys(consts.FIELDS_VALIDATORS);
    var fieldsSelectors = fieldsNames.map(function(name) {
        return '[name="' + name + '"]';
    }).join();

    this.fields = this.$form.find(fieldsSelectors).map(function(index, el) {
        return leadFormField($(el), validators);
    });
};

/**
 * Add form events listeners
 */
LeadForm.prototype.attachEvents = function() {
    // this.$form.on('change', this.onChange.bind(this));
    this.$form.on('submit', this.onSubmit.bind(this));
};

/**
 * Add OnSubmit Callback
 */
LeadForm.prototype.addOnSubmitCallback = function(cb) {
    this.submitCallbacks.add(cb);
};

/**
 * Check if the form is valid
 * @return {Promise} returns resolved/rejected promise when the form is valid/invalid
 */
LeadForm.prototype.isValid = function() {
    var promises = this.fields.map(function() {
        return this.isValid();
    });

    return $.when.apply($, promises);
};

/**
 * Validate the form and send a lead
 * @param  {Object} event
 * @return {Boolean}
 */
LeadForm.prototype.onSubmit = function(e) {
    this.$submitBtn.attr('disabled', true);
    var self = this;
    var creativeId = self.$submitBtn.closest('.edm-entry')[0].id;

    this.isValid().then(function() {
        var isValid = Array.prototype.every.call(arguments, function(val) { return val; });
        var fillFieldsErrorEl = self.$form.find('.fill-fields-error');
        fillFieldsErrorEl.toggleClass('hidden-xs-up', isValid);
        if(!isValid) {
            self.$submitBtn.attr('disabled', false);
            return false;
        }
        eventToolbox.fireAction({
            'event_type': 'action_progress',
            'ads': {
                'disable_refresh': true
            },
            'event_data': {
                'action_category': 'user',
                'action_name': 'lead_submission',
                'subaction_name': 'attempt_submit',
                'action_cause': 'button_click',
                'valid':'y',
                'error':'',
                'total':$('input[type=checkbox]:checked').length,
                'creative_id': creativeId
            }
        });
        self.submitCallbacks.fire(e);
    }).catch(function() {
        var err = $('.form-control-danger').map(function(index,value){
            return value.name;
        }).get().join(',');
        self.$submitBtn.attr('disabled', false);
        eventToolbox.fireAction({
            'event_type': 'action_progress',
            'ads': {
                'disable_refresh': true
            },
            'event_data': {
                'action_category': 'user',
                'action_name': 'lead_submission',
                'subaction_name': 'attempt_submit',
                'action_cause': 'button_click',
                'valid': 'n',
                'error': err,
                'total':$('input[type=checkbox]:checked').length,
                'creative_id': creativeId
            }
        });
    });

    return false;
};

/**
 * Clear
 */
LeadForm.prototype.clear = function() {
    this.submitCallbacks.empty();
    this.$form.off();
    this.$submitBtn = null;
    this.fields = null;
    this.$form = null;
};

/**
 * @example
 * require('src/interlock/no-ui/validation/lead').createLeadForm($('#vdp-lead'));
 */
module.exports = {
    createLeadForm: function($form, options) {
        return new LeadForm($form, options);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/validation/lead/index.js
// module id = 131
// module chunks = 0 1 16 19 21